import React from "react";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { BsPlayFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";

function OneRecording({ recording, event }: any) {
  const navigate = useNavigate();

  const handleReplayButton = () => {
    navigate("/ppv/replay/" + event?.slug + "/" + recording?.stream_key, {
      state: { prevPage: event?.slug },
    });
  };

  return (
    <button
      onClick={handleReplayButton}
      className="group flex w-full items-center gap-4 rounded-xl border border-white/5 bg-white/[0.03] px-4 py-3 text-left transition-all duration-300 hover:border-[#f30543]/30 hover:bg-white/[0.06]"
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 text-white transition-all duration-300 group-hover:bg-[#f30543] group-hover:shadow-[0_4px_14px_rgba(243,5,67,0.4)]">
        <BsPlayFill className="ml-0.5 text-[20px]" />
      </div>

      <div
        className="min-w-0 flex-1"
        data-tooltip-id={
          recording?.title?.length > 30
            ? `ppv-recording-${recording?.title}`
            : ""
        }
      >
        <p className="truncate text-[15px] font-semibold text-white max-sm:text-[13px]">
          {decodeHtmlEntities(recording?.title)}
        </p>
        {recording?.description && (
          <p className="truncate text-[12px] text-white/50 max-sm:text-[10px]">
            {decodeHtmlEntities(recording?.description)}
          </p>
        )}
        <ReactTooltip
          id={`ppv-recording-${recording?.title}`}
          place="top"
          content={recording?.title}
          style={{ width: "180px", zIndex: 50 }}
        />
      </div>
    </button>
  );
}

export default OneRecording;
